import { render, staticRenderFns } from "./TraineeStatus.vue?vue&type=template&id=40a4884b"
import script from "./TraineeStatus.vue?vue&type=script&lang=js"
export * from "./TraineeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports